import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

const updateUserNotificationsSettings = async (payload) => {
  const userId = useUserStore.getState().userId

  return request({
    url: `users/${userId}/notifications`,
    method: 'PUT',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    data: payload,
  })
}

export const useUpdateNotificationsSettings = () => {
  const queryClient = useQueryClient()
  const { mutate, isLoading, isError, error } = useMutation(updateUserNotificationsSettings, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['notifications'])
    },
  })

  return { mutate, isLoading, isError, error }
}
